import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import PopUpWrapper from "./modal-wrapper";
import { Button } from "components/ui-kit/styled-templates";
import useModal from "hooks/useModal";
import { EModals } from "types/enums";

const REQUIRED_FIELDS = [
    { key: 'userUniversityId', label: 'ВУЗ' },
    { key: 'departureCity', label: 'Город' },
    { key: 'name', label: 'ФИО' },
    { key: 'phone', label: 'Телефон' },
    { key: 'gender', label: 'Пол' },
    { key: 'birthday', label: 'Дата рождения' },
    { key: 'studentRoleType', label: 'Тип студента' }
];

export const isFieldEmpty = (value: any) =>
    value === undefined || value === null || value === '';

export const getMissingFields = (user: any) =>
    REQUIRED_FIELDS.filter(f => isFieldEmpty(user?.[f.key]));

const ProfileIncompleteModal = () => {
    const navigate = useNavigate();
    const { close, state: modalState = {} } = useModal(EModals.ProfileIncomplete, {});
    const { missingFields = [] } = modalState as { missingFields: typeof REQUIRED_FIELDS };

    const handleGoToProfile = () => {
        close();
        navigate('/profile');
    };

    return (
        <PopUpWrapper name={EModals.ProfileIncomplete} withCros={true}>
            <Content>
                <Title>Заполните профиль</Title>
                <Description>
                    Для полноценного использования платформы, пожалуйста, заполните следующие поля в вашем профиле:
                </Description>
                <FieldsList>
                    {missingFields.map((field, index) => (
                        <FieldItem key={field.key}>
                            <FieldBullet>•</FieldBullet>
                            <FieldLabel>{field.label}</FieldLabel>
                        </FieldItem>
                    ))}
                </FieldsList>
                <ButtonsRow>
                    <Button background="green" onClick={handleGoToProfile}>
                        Заполнить профиль
                    </Button>
                    <LaterButton onClick={close}>
                        Позже
                    </LaterButton>
                </ButtonsRow>
            </Content>
        </PopUpWrapper>
    );
};

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

const Title = styled.h2`
    margin: 0 0 16px 0;
    font-family: "Noto Sans", sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #212121;
`;

const Description = styled.p`
    margin: 0 0 20px 0;
    font-family: "Noto Sans", sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #666;
`;

const FieldsList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    max-width: 300px;
    margin-bottom: 24px;
    background: #f4f9fc;
    border-radius: 8px;
    padding: 16px 20px;
`;

const FieldItem = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    &:last-child {
        margin-bottom: 0;
    }
`;

const FieldBullet = styled.span`
    color: #ef4058;
    margin-right: 10px;
    font-size: 18px;
`;

const FieldLabel = styled.span`
    font-family: "Noto Sans", sans-serif;
    font-size: 15px;
    color: #333;
`;

const ButtonsRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
`;

const LaterButton = styled.button`
    background: none;
    border: none;
    color: #666;
    font-family: "Noto Sans", sans-serif;
    font-size: 14px;
    cursor: pointer;
    text-decoration: underline;

    &:hover {
        color: #333;
    }
`;

export default ProfileIncompleteModal;
